// eslint-disable-next-line import/no-extraneous-dependencies
import axios from 'axios';

const customAxios = axios.create();

const getValidToken = (token: any) => {
  if (!token || `${token}` === 'null' || `${token}` === 'undefined') {
    return null;
  }
  return token;
};

customAxios.interceptors.request.use((request: { headers: any; }) => {
  const token = localStorage.getItem('interactiveToken');
  const interactiveToken = getValidToken(token);
  const newReq = {
    ...request,
    headers: {
      ...request.headers,
      interactiveToken: interactiveToken || '',
    },
  };
  return newReq;
});

customAxios.interceptors.response.use(
  (response: any) => response,
  (error: { response: { status: any; }; }) => {
    const { status } = error.response;
    // Go to login page if getting 401.
    if (status === 401) {
      console.log('redirect to the interactive login page');
    }
    return Promise.reject(error);
  },
);

export default customAxios;
